export const isVideo = url => {
  const videoExt = /\.(mp4|webm|ogv)/
  return videoExt.test(url)
}
